import requests from "./httpServiceKey";
const LoginService = {
  // registerAdmin: async (body) => {
  //   return requests.post("/admin/register", body);
  // },
 
  loginEmployee: async (body) => {
    return requests.post(`/users/login`, body);
  },

  forgetPassword: async (body) => {
    
    return requests.put("/users/forgot-password", body);
  },

  resetPassword: async (body) => {
    return requests.put("/users/reset-password", body);
  },

  // signUpWithProvider: async (body) => {
  //   return requests.post("/admin/signup", body);
  // },

  
};

export default LoginService;
